export default "__VITE_ASSET__BqBIoDRL__"